<template>
  	<CampaignList />
</template>

<script>

// @ is an alias to /src
import CampaignList from "@/components/CampaignList.vue";

export default {
  name: "CampaignLists",
  components: {
    CampaignList,
  },
};
</script>
